import { NetworkError } from "../error/networkError";

export interface NetworkInit extends RequestInit {
  json?: Record<string, any>;
}

export async function network<T>(
  app: string,
  endpoint: string,
  init?: NetworkInit,
): Promise<T> {
  const _init = init || {};
  const root = `/${app}/api`;
  const url = `${root}${endpoint}`;

  if (_init.json) {
    _init.body = JSON.stringify(_init.json);
    _init.headers = {
      ..._init.headers,
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    delete _init.json;
  }

  const response = await fetch(url, _init);
  const json = await response.json();

  if (!response.ok) {
    throw new NetworkError(response.status, json.error);
  }

  return json;
}
